<template>
  <v-container fluid>
    <!-- Sidebar -->
    <SidebarNavigation />

    <v-card>
      <v-row class="pt-3 pl-1">
        <v-col cols="2.5" style="max-width: 250px">
          <v-menu
            v-model="pagination.startMenu"
            :close-on-content-click="false"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                readonly
                v-model="pagination.startDate"
                label="Tanggal Awal"
                v-bind="attrs"
                v-on="on"
                dense
                outlined
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="pagination.startDate"
              @input="onDateChange"
              locale="id"
            ></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="2.5" style="max-width: 250px">
          <v-menu
            v-model="pagination.endMenu"
            :close-on-content-click="false"
            transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="pagination.endDate"
                label="Tanggal Akhir"
                readonly
                v-bind="attrs"
                v-on="on"
                dense
                outlined
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="pagination.endDate"
              @input="onDateChange"
              locale="id"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="2.5" style="max-width: 180px">
          <v-autocomplete
            item-text="status_name"
            item-value="status"
            :items="statusOptions"
            v-model="pagination.selectedstatus"
            @change="updateQuery('status', $event)"
            label="Status"
            dense
            outlined
          ></v-autocomplete>
        </v-col>

        <v-col cols="2.5">
          <v-btn color="primary" @click="exportToExcel"> Download </v-btn>
        </v-col>
        <v-col cols="2.5">
          <v-text-field
            v-model="pagination.search"
            label="Search"
            append-icon="mdi-magnify"
            dense
            hide-details
            class="search-input"
            style="max-width: 250px"
            outlined
            @input="debouncedSearch"
          ></v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-data-table
            mobile-breakpoint="0"
            fixed-header
            dense
            class="elevation-5"
            :headers="tableHeaders"
            :items="pointRedeemList"
            :items-per-page.sync="pagination.itemsPerPage"
            :page.sync="pagination.page"
            :sort-by="pagination.sortBy"
            :sort-desc="pagination.sortDesc"
            :loading="isLoading"
            :server-items-length="totalPointRedeem"
            item-key="id"
            @update:page="updateQuery('page', $event)"
            @update:items-per-page="updateQuery('itemsPerPage', $event)"
            @update:sort-by="updateQuery('sortBy', $event)"
            @update:sort-desc="updateQuery('sortDesc', $event)"
          >
            <template v-slot:body="{ items }">
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.points.toLocaleString() }}</td>
                  <td>Rp {{ parseInt(item.amount).toLocaleString() }}</td>
                  <td>{{ item.status }}</td>

                  <td>
                    <div class="small-font">
                      {{ item.created_by_name }}
                    </div>
                    <div class="small-font">
                      {{ item.created_on }}
                    </div>
                  </td>
                  <td>
                    <v-tooltip
                      bottom
                      v-if="
                        item.status === 'pending' && user.mst_division_id === 5
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          @click="openApprovalDialog('approve', item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon color="success">mdi-check</v-icon>
                        </v-btn>
                      </template>
                      Approve
                    </v-tooltip>

                    <v-tooltip
                      bottom
                      v-if="
                        item.status === 'pending' && user.mst_division_id === 5
                      "
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="red"
                          @click="openApprovalDialog('reject', item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>mdi-close</v-icon>
                        </v-btn>
                      </template>
                      Reject
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>

    <!-- suggestion Dialog -->
    <v-dialog v-model="isDialogOpen" max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ dialogTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-form v-model="isFormValid">
            <!-- <v-text-field
              v-model="pointToken"
              v-show="isVisiblePointToken"
              label="Token Point"
              required
            ></v-text-field> -->
            <v-textarea
              v-model="approvalFormData.comments"
              label="Catatan"
              required
            ></v-textarea>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="isDialogOpen = false">Cancel</v-btn>
          <v-btn color="primary" :disabled="!isFormValid" @click="submit"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Snackbar Notifications -->
    <snackbarMessage />
  </v-container>
</template>

<script>
import api from "@/utils/api";
import SidebarNavigation from "@/components/SidebarNavigation.vue";
import snackbarMessage from "@/components/snackbarMessage.vue";
import store from "@/store";
import { getLast30Days } from "@/utils/date";
import exceljs from "exceljs";
import { saveAs } from "file-saver";
import { dateFormatDmy } from "@/utils/date";

export default {
  components: {
    SidebarNavigation,
    snackbarMessage,
  },
  data() {
    return {
      approvalFormData: {
        id: null,
        comments: "",
        status: "",
      },
      dialogTitle: "",
      tableHeaders: [
        { text: "Point", align: "center", value: "point" },
        { text: "Amount", align: "center", value: "amount" },
        { text: "Status", align: "center", value: "status" },
        { text: "Dibuat Oleh", align: "center", value: "id" },
        { text: "Aksi", align: "center", value: "actions", sortable: false },
      ],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: "id",
        sortDesc: false,
        startMenu: false,
        endMenu: false,
        selectedstatus: "all",
        startDate: getLast30Days().start,
        endDate: getLast30Days().end,
        search: "",
      },
      pointRedeemList: [],
      pointToken: "",
      pointTokenExpires: null,
      totalPointRedeem: 0,
      point: 0,
      exchangePoints: 0, // Jumlah poin yang ingin ditukar
      pointRate: 100, // 1 poin = 100 rupiah
      isDialogOpen: false,
      dialogPointToken: false,
      isFormValid: false,
      isLoading: false,
      isVisiblePointToken: false,
      statusOptions: [
        {
          status: "all",
          status_name: "All",
        },
        {
          status: "pending",
          status_name: "Pending",
        },
        { status: "approved", status_name: "Approved" },
        { status: "rejected", status_name: "Rejected" },
      ],
      exportColumns: [
        { key: "points", label: "Point" },
        { key: "amount", label: "Amount" },
        { key: "status", label: "Status" },
        { key: "created_by_name", label: "Nama karyawan" },
      ],
    };
  },
  methods: {
    async fetchVerification() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: query.sortDesc || this.pagination.sortDesc || true,
        status: query.status || this.status,
        startDate: query.startDate || this.startDate,
        endDate: query.endDate || this.endDate,
      };

      await api
        .get("/points/verification", { params })
        .then(({ data }) => {
          // console.log(data);
          this.pointRedeemList = data.data.data;
          this.totalPointRedeem = data.data.total;
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    openApprovalDialog(mode, params = null) {
      this.mode = mode;
      if (mode === "approve") {
        this.isVisiblePointToken = true;
      } else {
        this.isVisiblePointToken = false;
      }
      this.dialogTitle =
        mode.charAt(0).toUpperCase() + mode.slice(1).toLowerCase();

      this.approvalFormData.id = params.id;
      this.isDialogOpen = true;
      this.isSuggestionCategoryLoading = false;
    },
    async exportToExcel() {
      // Tampilkan loading
      store.dispatch("showLoading");
      this.isLoading = true;
      const query = this.$route.query;

      const params = {
        page: parseInt(query.page) || this.pagination.page,
        limit: parseInt(query.itemsPerPage) || this.pagination.itemsPerPage,
        search: query.search || this.pagination.search,
        sortBy: query.sortBy || this.pagination.sortBy || "id",
        sortDesc: query.sortDesc || this.pagination.sortDesc || true,
        status: query.status || this.status,
        startDate: query.startDate || this.startDate,
        endDate: query.endDate || this.endDate,
      };

      await api
        .get("/points/verification", { params })
        .then(({ data }) => {
          const dataExcel = data.data.data;

          // Buat workbook dan worksheet
          const workbook = new exceljs.Workbook();
          const worksheet = workbook.addWorksheet("Data Export");

          // Tambahkan header ke worksheet
          const headerRow = this.exportColumns.map((col) => col.label);
          worksheet.addRow(headerRow);

          // Tambahkan data ke worksheet
          dataExcel.forEach((item) => {
            worksheet.addRow(this.exportColumns.map((col) => item[col.key]));
          });

          // Styling header (Bold + Background Color + Center)
          worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { horizontal: "center", vertical: "middle" };
            cell.fill = {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "FFFF00" }, // Kuning
            };
          });

          // Styling semua sel agar center
          worksheet.eachRow((row) => {
            row.eachCell((cell) => {
              cell.alignment = { horizontal: "center", vertical: "middle" };
            });
          });

          // Auto width untuk setiap kolom
          worksheet.columns.forEach((column) => {
            let maxLength = 0;
            column.eachCell({ includeEmpty: true }, (cell) => {
              maxLength = Math.max(
                maxLength,
                cell.value ? cell.value.toString().length : 10
              );
            });
            column.width = maxLength + 2; // Tambahkan padding
          });

          // Simpan file Excel
          workbook.xlsx.writeBuffer().then((buffer) => {
            const blob = new Blob([buffer], {
              type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
            });
            saveAs(
              blob,
              `redeem_point_(${dateFormatDmy(
                this.pagination.startDate
              )}_sampai_${dateFormatDmy(this.pagination.endDate)}).xlsx`
            );
          });
        })
        .catch((error) => {
          console.error("Error fetching suggestion:", error);
        })
        .finally(() => {
          this.isLoading = false;
          // Sembunyikan loading setelah request selesai
          store.dispatch("hideLoading");
        });
    },
    submit() {
      store.dispatch("showLoading");
      this.approvalFormData.status = this.mode;
      // this.approvalFormData.point_token = this.pointToken;
      const payload = { ...this.approvalFormData };

      api
        .post("/points/verification", payload)
        .then((response) => {
          // Mengambil pesan dari backend
          const message = response.data.message; // Pesan dari backend

          // Menampilkan pesan dengan status "success" (hijau)
          this.fetchVerification(); // Fungsi untuk mengambil data karyawan terbaru
          this.isDialogOpen = false;

          // Memanggil action Vuex untuk menampilkan snackbar dengan status success (hijau)
          store.dispatch("triggerSnackbar", { message, isSuccess: true });
        })
        .catch((error) => {
          let message = "Failed to save verification!"; // Pesan default jika error

          if (error.response) {
            // Jika ada respons error dari backend
            message = error.response.data.message || message; // Pesan error dari backend (jika ada)
          } else {
            message = error.message || message; // Pesan error default
          }

          // Menampilkan snackbar dengan status error (merah)
          store.dispatch("triggerSnackbar", {
            message,
            isSuccess: false,
          });
        })
        .finally(() => {
          this.isLoading = false;
          store.dispatch("hideLoading");
        });
    },
    debouncedSearch() {
      this.updateQuery("search", this.pagination.search);
    },
    onDateChange() {
      // Update query parameters saat tanggal berubah
      if (this.pagination.startDate) {
        this.updateQuery("startDate", this.pagination.startDate); // Update startDate
      }
      if (this.pagination.endDate) {
        this.updateQuery("endDate", this.pagination.endDate); // Update endDate
      }
    },
    updatePagination(query) {
      this.pagination.page = parseInt(query.page) || 1;
      this.pagination.itemsPerPage = parseInt(query.itemsPerPage) || 10;
      this.pagination.sortBy = query.sortBy || "id";
      this.pagination.sortDesc = query.sortDesc === "true" ? true : false;
      this.pagination.search = query.search || this.pagination.search || "";
      this.pagination.selectedstatus =
        query.status || this.pagination.selectedstatus;
      this.pagination.startDate = query.startDate || this.pagination.startDate;
      this.pagination.endDate = query.endDate || this.pagination.endDate;
    },
    updateQuery(key, value) {
      if (this.$route.query[key] !== value) {
        this.$router
          .push({
            query: {
              ...this.$route.query,
              [key]: value, // Mengupdate parameter query dengan key dan value
            },
          })
          .catch((err) => {
            // Handle error jika ada (contohnya, karena navigasi yang redundant)
            if (err.name !== "NavigationDuplicated") {
              console.error(err);
            }
          });
      }
      this.updatePagination(this.$route.query);
    },
  },
  watch: {
    pagination: {
      handler: "fetchVerification",
      deep: true, // Memastikan perubahan dalam objek pagination terdeteksi
    },
  },
  mounted() {
    store.commit("setTitle", "Verifikasi");
    this.fetchVerification();
    // console.log(this.user.mst_employee_id);
    this.updatePagination(this.$route.query);
  },
  computed: {
    user() {
      return store.getters["user/getUser"] || {}; // get Data User
    },
  },
};
</script>

<style scoped>
.v-data-table td:nth-child(1),
td:nth-child(2),
td:nth-child(3),
td:nth-child(4),
td:nth-child(5) {
  text-align: center;
}
</style>
